import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { exerciseUrls, roles } from '../../common/config'
import { deleteLesson, removeFavoriteLesson, addFavoriteLesson,
  loadLessons, setCurrentLesson } from '../../common/lessons/actions'
import EmptyList from '../components/EmptyList'
import Button from '../components/Button'
import Tag from '../components/Tag'

class LessonsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      savedLessons: [],
    }
  }

  componentDidCatch(error, info) {
    console.log('error - LessonsList')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidMount() {
    const { isLessonsPage, loadLessons, viewer } = this.props
    if (!isLessonsPage && viewer) {
      loadLessons()
    }
  }

  saveLesson(lessonId) {
    this.setState({
      savedLessons: [...this.state.savedLessons, lessonId],
    })
    this.props.addFavoriteLesson(lessonId)
  }

  render() {
    const {
      lessons,
      userLessons,
      deleteLesson,
      isLessonsPage,
      isSearchPage,
      viewer,
      setCurrentLesson,
      isTestForm,
      intl,
    } = this.props
    const { savedLessons } = this.state
    const lessonLink = viewer && viewer.role === roles.TEACHER ? '/app/create-test/' : '/app/practice/'
    
    const lessonLinkText = viewer && viewer.role === roles.TEACHER ?
      intl.formatMessage(messages.createTest)
    :
      intl.formatMessage(messages.test)

    const userLessonsVisible = isLessonsPage
    const ownLessons = (userLessons && userLessons.toJS()) || [] 

    return (
      <div className="lessons-list">
        {
          lessons.length ?
            lessons.map(lesson =>
              (
                <div className="item-box" key={lesson.id}>
                  <div className="flex-column">
                    <div
                      className="lesson-search-title"
                      onClick={isSearchPage ? () => setCurrentLesson(lesson) : null}
                    >
                      <img className="lesson-icon" src={`/assets/icons/${lesson.type}2.png`} alt="Lesson" />
                      <h3>
                        {
                          isSearchPage ?
                            lesson.name
                          :
                            <Link to={`/lessons/${lesson.id}`}>
                              {lesson.name}
                            </Link>
                        }
                      </h3>
                      {
                        isSearchPage && lesson.createdBy && lesson.createdBy.name &&
                        <span
                          className="grey-text created-by"
                        >
                          ({intl.formatMessage(messages.createdBy)} <Link to={`/app/user/${lesson.createdBy._id}`}>
                            {lesson.createdBy.name}</Link>)
                        </span>
                      }
                    </div>
                    <div className="lesson-tags-list">
                      {
                        lesson.tags.map(tag => <Tag key={tag.id} small tag={tag} />)
                      }
                    </div>
                  </div>
                  {
                    userLessonsVisible ?
                      <div className="lessons-buttons">
                        <Link to={`${lessonLink}${lesson.id}`}>
                          <Button positive>
                            {lessonLinkText}
                          </Button>
                        </Link>
                        <Link to={`/app/edit-${exerciseUrls[lesson.type]}/${lesson.id}`}>
                          <Button icon="edit">{intl.formatMessage(messages.edit)}</Button>
                        </Link>
                        <Button
                          negative
                          icon="trash"
                          onClick={() => deleteLesson(lesson.id)}
                          className="disable-spacing-right"
                        >
                          {intl.formatMessage(messages.delete)}
                        </Button>
                      </div>
                    :
                      (viewer || isSearchPage) ?
                        <div className="lessons-buttons">
                          <Button
                            positive
                            onClick={() => this.saveLesson(lesson.id)}
                            disabled={savedLessons.includes(lesson.id) ||
                              ownLessons.some(l => l.id === lesson.id)}
                          >
                            {intl.formatMessage(isTestForm ? messages.addToTest : messages.save)}
                          </Button>
                        </div>
                      :
                        <div className="lessons-buttons">
                          <Link to={`/vocabulary-learn/${lesson.id}`}>
                            <Button positive >
                              {intl.formatMessage(messages.learn)}
                            </Button>
                          </Link>
                        </div> 
                  }
                </div>
            ),
          )
          :
            isLessonsPage &&
            <EmptyList
              title={intl.formatMessage(messages.noexercises)}
              text={intl.formatMessage(messages.exercisesWillShow)}
            />
        }
      </div>
    )
  }
}


LessonsList.defaultProps = {
  lessons: [],
  type: '',
  isSearchPage: false,
  isLessonsPage: false,
  isTestForm: false,
  userLessons: null,
  viewer: null,
}

LessonsList.propTypes = {
  lessons: PropTypes.array,
  userLessons: PropTypes.object,
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  loadLessons: PropTypes.func.isRequired,
  deleteLesson: PropTypes.func.isRequired,
  addFavoriteLesson: PropTypes.func.isRequired,
  setCurrentLesson: PropTypes.func.isRequired,
  isSearchPage: PropTypes.bool,
  isLessonsPage: PropTypes.bool,
}

const enhance = compose(
  connect((state) => ({
    userLessons: state.lessons.all,
    viewer: state.users.viewer,
  }),
  { deleteLesson, loadLessons, removeFavoriteLesson, addFavoriteLesson, setCurrentLesson }),
  injectIntl,
)

export default enhance(LessonsList)

const messages = defineMessages({
  test: {
    id: 'lessons.list.test',
    defaultMessage: 'Test',
  },
  save: {
    id: 'lessons.list.save',
    defaultMessage: 'Uložiť',
  },
  addToTest: {
    id: 'lessons.list.addToTest',
    defaultMessage: 'Pridať do testu',
  },
  learn: {
    id: 'lessons.list.learn',
    defaultMessage: 'Učiť sa',
  },
  edit: {
    id: 'lessons.list.edit',
    defaultMessage: 'Upraviť',
  },
  delete: {
    id: 'lessons.list.delete',
    defaultMessage: 'Vymazať',
  },
  createTest: {
    id: 'lessons.list.createTest',
    defaultMessage: 'Vytvoriť test',
  },
  createdBy: {
    id: 'lessons.list.createdBy',
    defaultMessage: 'vytvorené uživateľom',
  },
  noexercises: {
    id: 'lessons.list.noexercises',
    defaultMessage: 'Zatiaľ nemáte žiadne uložené cvičenia.',
  },
  exercisesWillShow: {
    id: 'lessons.list.exercisesWillShow',
    defaultMessage: 'Tu sa zobrazia Vaše cvičenia, z ktorých môžete vytvárať testy.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/LessonsList.js